import { Component, ElementRef, ViewChild } from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AccountService} from "../../../account/account.service";
import {CashInService} from "../cashIn.service";
import {CashInModel} from "../cashIn.model";
import {AuthService} from "../../../../shared/services/auth.service";
import { ToastrService } from 'ngx-toastr';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import { CASHIN_COUNTRY_FIELDS } from '../cashInFields';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-cashIn',
  templateUrl: './cashIn.component.html',
  styleUrls: ['./cashIn.component.scss']
})
export class CashInComponent {
  cashIn = new FormGroup({
    documento: new FormControl<string>('',[Validators.required]),
    nome: new FormControl<string>('',Validators.required),
    valor: new FormControl<number | null>(null,[Validators.required, Validators.min(1)]),
    taxa: new FormControl<number>(0),
    valorTotal: new FormControl<number>(0),
    origem: new FormControl<string>('', Validators.required)
  });

  public CASHIN_COUNTRY_FIELDS = CASHIN_COUNTRY_FIELDS;
  public countryForm!: FormGroup;          
  public showCountryForm = false;
  public isCountryFormSubmitted = false;
  public depositSuccess = false;
  public checkoutUrl: string = '';

  originCurrency = this.authService.getOriginCurrency();

  public isSubmitted:boolean;
  public documentFeedBack: string;
  public nomeFeedBack: string;
  public valorFeedBack: string;
  public origemFeedBack: string;

  public depositTaxValue: number = 0;
  public depositTaxPercent: number = 0;

  
  public isLoaded: boolean;
  
  public originList: { name: string; value: string }[] = [];

  constructor(private accountService : AccountService,
              private cashInService : CashInService,
              private authService: AuthService,
              private toastr: ToastrService,
              private modalService: NgbModal) {
    this.getEnum();
    this.getAccountValues();
    this.isSubmitted = false;
    this.documentFeedBack = '';
    this.nomeFeedBack = '';
    this.valorFeedBack = '';
    this.origemFeedBack = '';
    this.isLoaded = true;
    this.originList = [];
  }

  public getAccountValues(){
    this.accountService.getAccount().then(
      value => {
        this.depositTaxValue = value.depositTaxValue;
        this.depositTaxPercent = value.depositTaxPercent;
      }
    );
  }

 private getEnum(): void {
  this.cashInService.getEnum()               
    .then(resp => {
      this.originList = [
        ...resp.valuesCashIn.map((v: string) => ({ name: v, value: v }))
      ];
    });
} 

public openCheckoutUrl(): void {
  if (this.checkoutUrl) {
    window.open(this.checkoutUrl, '_blank');
  }
}

  public transformValue = (value: string | number | undefined | null): string => {
    return String(Number(value) / 100);
  };

  public valorChanged() {
    let valor = Number(this.cashIn.controls.valor.value);
    this.cashIn.controls.valor.setValue(valor)
    let taxa = ( valor * this.depositTaxPercent) / 100;
    taxa = valor > 0 ? (taxa + this.depositTaxValue) : 0;
    let valorTotal = valor > 0 ? (valor - taxa) : 0;
    this.cashIn.controls.taxa.setValue(taxa);
    this.cashIn.controls.valorTotal.setValue(valorTotal);
  }

  makeDeposit(): void {
    this.isSubmitted = true;

    if (!this.formIsValid()) { 
        return; 
    }

    if (this.originCurrency === 'MXN') {
      this.sendRequest(this.buildPayload());
      return;
    }

    this.showCountryForm = true;
    this.buildCountryForm();
  }

  private buildCountryForm(): void {
    const cfg = CASHIN_COUNTRY_FIELDS[this.originCurrency];
    const group: any = {};
    cfg.forEach(f => group[f.name] = new FormControl('', f.validators));
    this.countryForm = new FormGroup(group);
    this.isCountryFormSubmitted = false;
  }

  confirmCountryForm(): void {
    this.isCountryFormSubmitted = true;
    if (this.countryForm.invalid) { return; }

    const countryData = this.countryForm.value!;
    const basePayload = this.buildPayload();
    let request: any = { ...basePayload };

    switch (this.originCurrency) {
      case 'CLP':
        request.extraClpCashIn = {
          customerName: countryData.customerName,
          customerEmail: countryData.customerEmail,
          documentNumber: countryData.documentNumber,
          documentType: countryData.documentType
        };
        break;
      case 'MXN':
        request.extraMxnCashIn = {
          repeat: countryData.repeat,
          minAmount: countryData.minAmount,
          maxAmount: countryData.maxAmount
        };
        break;
      case 'COP':
        request.extraCopCashIn = {
          step: countryData.step,
          customerName: countryData.customerName,
          customerPhone: countryData.customerPhone,
          customerEmail: countryData.customerEmail,
          documentNumber: countryData.documentNumber,
          documentType: countryData.documentType,
          bankCode: countryData.bankCode,
          accountNo: countryData.accountNo
        };
        break;
      case 'PEN':
        request.extraPenCashIn = {
          customerName: countryData.customerName,
          customerPhone: countryData.customerPhone,
          customerEmail: countryData.customerEmail,
          documentNumber: countryData.documentNumber,
          documentType: countryData.documentType
        };
        break;
      default:
        break;
}

    this.sendRequest(request);
  }
  
  private buildPayload() {
    return {
      person: {
        document: this.cashIn.value.documento,
        name:     this.cashIn.value.nome
      },
      value :  this.cashIn.value.valor,
      origin:  this.cashIn.value.origem?.toUpperCase()
    } as CashInModel;
  }
  
  private sendRequest(request: CashInModel): void {
  this.cashInService.sendDeposit(request).subscribe({
    next: (res) => {
      if (res.success) {
        this.checkoutUrl = res.urlCheckOut;
        this.depositSuccess = true;
        this.toastr.success(res.message || 'Depósito realizado com sucesso!');
      } else {
        this.toastr.error(res.message || 'Erro ao realizar depósito.');
      }
    },
    error: (err) => {
      const errorMsg = err?.error?.message || 'Erro inesperado ao realizar depósito.';
      this.toastr.error(errorMsg);
    }
    });
  }

  public copyLinkToClipboard(): void {
    navigator.clipboard.writeText(this.checkoutUrl)
      .then(() => this.toastr.success('Link copiado para a área de transferência!'))
      .catch(() => this.toastr.error('Erro ao copiar o link.'));
  }

  public formIsValid() : boolean{
    if(this.cashIn.controls.documento.value!.length === 11 && !cpf.isValid(this.cashIn.controls.documento.value!) ||
       this.cashIn.controls.documento.value!.length === 14 && !cnpj.isValid(this.cashIn.controls.documento.value!))
    {
      this.cashIn.controls.documento.setErrors(Validators.required)
      this.documentFeedBack = 'Documento inválido!';
    }
    if(this.cashIn.controls.documento.hasError('required')){
      this.documentFeedBack = 'Documento é obrigatório!';
    }
    if(this.cashIn.controls.nome.invalid){
      this.nomeFeedBack = 'Nome é obrigatório!';
    }
    if(this.cashIn.controls.valor.hasError('min')){
      this.valorFeedBack = 'Valor inválido - Valor mínimo R$ 1,00!';
    }else if(this.cashIn.controls.valor.invalid){
      this.valorFeedBack = 'Valor é obrigatório!';
    }
    if(this.cashIn.controls.origem.hasError('required')){
      this.origemFeedBack = 'Origem é obrigatória!'
    }
    return this.cashIn.valid;
  }

}
